//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
export default {
  name: "InspectionRecordPointModal",
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: "巡检记录点表单",
      tableName: "om_inspection_record_point",
      form_fields: ['recordId', 'pointId', 'val', 'realCoordinate', 'coordinateDiff'],
      form_fields_time: [],
      validatorRules: {
        recordId: {
          rules: [{
            required: true,
            message: '请输入巡检记录!'
          }]
        },
        pointId: {
          rules: [{
            required: true,
            message: '请输入巡检点ID!'
          }]
        }
      }
    };
  },
  props: ['pagePath'],
  created: function created() {},
  methods: {}
};